import { render, staticRenderFns } from "./CrossSellsModal.vue?vue&type=template&id=44dbf99e&scoped=true&"
import script from "./CrossSellsModal.vue?vue&type=script&lang=js&"
export * from "./CrossSellsModal.vue?vue&type=script&lang=js&"
import style0 from "./CrossSellsModal.vue?vue&type=style&index=0&id=44dbf99e&prod&lang=scss&scoped=true&"
import style1 from "./CrossSellsModal.vue?vue&type=style&index=1&id=44dbf99e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44dbf99e",
  null
  
)

export default component.exports